export {mergeStateOfDevices} from "views/Status/Interfaces/DataWires/api";

const pCapAsCode = (access, inet) => (Number(access) << 1) | Number(inet);

const asWireDefinition = ({ acc, inet }) =>
  `${acc.iface} ${inet.iface} ${pCapAsCode(acc.pcap, inet.pcap)}`;

const notDeleted = ({ deleted = false }) => deleted !== true;

const requiresAtLeast = (min = 0, items, message = "unknown error") => {
  if (items.length < min) {
    throw message;
  }
  return items;
};

const wiresSettingCommand = (previous, wires) =>
  [
    "set wire",
    ...requiresAtLeast(
      1,
      wires.filter(notDeleted).map(asWireDefinition),
      "At least one wire is mandatory"
    ),
  ].join(" ");

export const composeApplyCommand = (previous, { wires }) =>
  wiresSettingCommand(previous.wires, wires).trim("\n");

const yesOrNoOrValue = (value) =>
  value === "yes" ? true : value === "no" ? false : value;

export const parseWires = (response) => {
  const [head, ...rows] = response.trim("\n").split("\n");
  const headerAttrs = head.trim(/\s/).split(/\s+/);
  const indexHeaderMap = headerAttrs.reduce((acc, value, index)=>{
    acc[index]=value;
    return acc;
  },{});
  return rows.map((row)=> {
    const rowAttrs = row.trim(/\s/).split(/\s+/);
    const item = rowAttrs.reduce((acc, attr, index)=>{
      if(indexHeaderMap[index]==="BQN"){
        acc["bqn"] = attr;
      } else {
        const key = indexHeaderMap[index].toLowerCase();
        const [begin, end] = key.split("-");
        if(!acc[begin]){
          acc[begin]={[end]: attr};
        } else {
          acc[begin]={...acc[begin], [end]:yesOrNoOrValue(attr)};
        }
      }
return acc;
    },{});
    return item;
  })
};
